import { useCallback, useState, useEffect, useRef } from "react";

export default function useAvailableHeight() {
  const [node, setNode] = useState(null);
  const [availableHeight, setAvailableHeight] = useState(null);
  const observerRef = useRef(null);

  const contentRef = useCallback((el) => {
    setNode(el);
  }, []);

  useEffect(() => {
    if (!node) {
      setAvailableHeight(null);
      return;
    }

    const observer = new ResizeObserver(([entry]) => {
      setAvailableHeight(entry.contentRect.height);
    });
    observer.observe(node);
    observerRef.current = observer;

    return () => observer.disconnect();
  }, [node]);

  return { contentRef, availableHeight };
}
